var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editor)?_c('EditorContent',{class:[`tiptap-v4 text-start vp-${_vm.resolution}`, _vm.sid ? `--${_vm.sid}-text` : ''],attrs:{"editor":_vm.editor},nativeOn:{"click":function($event){return _vm.initer.apply(null, arguments)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }